export default {
    VINTE_HORAS: 1,
    TRINTA_HORAS: 2,
    QUARENTA_HORAS: 3,
}